import genericCurriculumFormEn from "./locales/en.json";

export const GENERIC_CURRICULUM_FORM_NS = "genericCurriculumForm" as const;

export const GenericCurriculumFormTranslations = {
  en: {
    [GENERIC_CURRICULUM_FORM_NS]: {
      ...genericCurriculumFormEn,
    },
  },
};
